module.exports = __webpack_public_path__ + "img/copy.832bc41f.svg";